module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_hu_hungarian-cb329e885950a7c054075d78aa6f1364.svg";